import apiService from './api'

/**
 * API сервис для работы с контрактами
 */
const contractApi = {
  /**
   * Получение списка доступных предметов для контракта
   * Endpoint: GET /api/contract/
   * Возвращает список скинов из инвентаря пользователя, доступных для контракта
   * @returns {Promise<Array>} Массив предметов
   */
  getAvailableItems: async () => {
    try {
      console.log('🔄 Загрузка доступных предметов для контракта...')
      const response = await apiService.makeRequest('/api/contract/', {
        method: 'GET',
      })
      
      // API возвращает { "contract": [...] }, извлекаем массив
      const items = response?.contract || response || []
      
      console.log('✅ Предметы для контракта загружены:', items?.length || 0)
      
      // Сортируем по цене от дорогих к дешевым
      if (Array.isArray(items)) {
        const sortedItems = items
          .map(item => ({
            ...item,
            price: parseInt(item.price) || 0, // Убеждаемся что price это число
          }))
          .sort((a, b) => b.price - a.price)
        
        return sortedItems
      }
      
      return []
    } catch (error) {
      console.error('❌ Ошибка загрузки предметов для контракта:', error)
      throw error
    }
  },

  /**
   * Запуск контракта с выбранными предметами
   * Endpoint: POST /api/contract/start/
   * @param {Array<string>} itemIds - Массив ID выбранных предметов (от 3 до 10)
   * @returns {Promise<Object>} Результат контракта с donors, donors_cost, win
   */
  startContract: async (itemIds) => {
    try {
      console.log('🎰 Запуск контракта с предметами:', itemIds)
      
      // Валидация количества предметов
      if (!Array.isArray(itemIds) || itemIds.length < 3 || itemIds.length > 10) {
        throw new Error('Необходимо выбрать от 3 до 10 предметов')
      }
      
      const response = await apiService.makeRequest('/api/contract/start/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(itemIds),
      })
      
      console.log('✅ Контракт выполнен:', response)
      
      // API возвращает { "contract": { donors: [...], donors_cost: 1216, win: {...} } }
      const contractData = response?.contract || {}
      
      return {
        donors: contractData.donors || [],
        donorsCost: contractData.donors_cost || 0,
        win: contractData.win || null,
      }
    } catch (error) {
      console.error('❌ Ошибка выполнения контракта:', error)
      throw error
    }
  },
}

export default contractApi
